import React from 'react'
import { Modal } from '../../../../../components/common/Modal'
import { ModalHeader } from '../../../../../components/common/Modal/ModalHeader'
import { ModalBody } from '../../../../../components/common/Modal/ModalBody'
import { SetDiscountCodeModalContent } from './SetDiscountCodeModalContent'

interface SetDiscountCodeModalProps {
  show: boolean
  close: () => void
  societyId?: string
}

export const SetDiscountCodeModal = ({
  show,
  close,
  societyId,
}: SetDiscountCodeModalProps): JSX.Element => {
  return (
    <Modal show={show}>
      {{
        header: <ModalHeader onClose={close}>Sätt rabattkod</ModalHeader>,
        body: (
          <ModalBody className="overflow-y-auto">
            <SetDiscountCodeModalContent societyId={societyId} close={close} />
          </ModalBody>
        ),
      }}
    </Modal>
  )
}
